import * as React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";
import { ICompasAIChatAction } from "@/types/compass.types";
import { Button } from "./ui/button";
import { getActionState } from "./action-items.utils";
const ActionItem = React.lazy(() => import("./ActionItem"));

interface ActionItemRowProps {
  action: ICompasAIChatAction;
  index: number;
  actionsLength: number;
  isExpanded: boolean;
  toggleExpansion: () => void;
  isGlobalEditMode: boolean;
  moveAction: (from: number, to: number) => void;
}

const ActionItemRow: React.FC<ActionItemRowProps> = ({
  action,
  index,
  actionsLength,
  isExpanded,
  toggleExpansion,
  isGlobalEditMode,
  moveAction,
}) => (
  <div className="flex items-center gap-1.5">
    <div className="flex-1">
      <ActionItem
        action={action}
        isExpanded={isExpanded}
        toggleExpansion={toggleExpansion}
        actionState={getActionState(action)}
        isGlobalEditMode={isGlobalEditMode}
      />
    </div>
    <div className="flex flex-col gap-1">
      {index > 0 && (
        <Button
          variant="outline"
          size="icon-sm"
          onClick={() => moveAction(index, index - 1)}
          className="rounded-full size-6"
        >
          <ArrowUp className="size-3" />
        </Button>
      )}
      {index < actionsLength - 1 && (
        <Button
          variant="outline"
          size="icon-sm"
          onClick={() => moveAction(index, index + 1)}
          className="rounded-full size-6"
        >
          <ArrowDown className="size-3" />
        </Button>
      )}
    </div>
  </div>
);

export { ActionItemRow };
